import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

export interface DocumentDetailsResponse {
  id: string;
  name: string;
  name_malay: string;
  name_mandarin: string;
  airports: string;
  parent_term_name: string;
  parent_term_id: string;
  project_airport_id: any;
  published: string;
  airport: string;
}

const fetchLandingPageContentDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/zone-parent/${id}`);

  return response?.data?.[0];
};

const fetchPassengerDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/zone-child/${id}`);

  return response?.data?.[0];
};

const useZonePageDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["zonePublic", id],
      enabled: false,
      queryFn: () => {
        return fetchLandingPageContentDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useZonePassengerPageDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["zonePassenger", id],
      enabled: false,
      queryFn: () => {
        return fetchPassengerDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useZonePageDocumentDetails, useZonePassengerPageDocumentDetails };
